<template>
  <GeminiScrollbar
    :autoshow="true"
    :style="{width: '13.54vw', minWidth: '260px'}"
    class="my-scroll-bar fullMenu"
  >
    <!-- <div class="fullMenu" v-bar='{preventParentScroll: true, scrollThrottle: 30}'> -->
    <Menu
      :accordion="accordion"
      :active-name="activeName"
      :open-names="openNames"
      :style="{width: '13.54vw', minWidth: '260px'}"
      @on-select="changeMenu"
      ref="sideMenu"
    >
      <MenuGroup title="系统功能" v-if="menuLayoutType != 'LEFT_TOP' && menus.system_menu">
        <template v-for="(item, index) in menus['system_menu']">
          <MenuItem
            :key="item.pathName+'-'+index"
            :name="item.pathName"
            v-if="item.children == undefined || item.children.length == 0 "
          >
            <div class="flex">
              <i :class="item.menuIcon || 'fa fa-image'" :size="iconSize"></i>
              <span class="layout-text">{{item.menuName}}</span>
            </div>
            <Badge
              :count="$store.getters.inboxCount"
              style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
              v-if="item.menuCode == 'inbox'"
            ></Badge>
            <Badge
              :count="$store.getters.todoCount"
              style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
              v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
            ></Badge>
          </MenuItem>
          <sub-side-menu :item="item" :key="'menu-'+item.pathName+'-index'" v-else></sub-side-menu>
        </template>
      </MenuGroup>
      <MenuGroup title="系统管理" v-if="menus['config_menu']">
        <template v-for="(item, index) in menus['config_menu']">
          <MenuItem
            :key="item.pathName+'-'+index"
            :name="item.pathName"
            v-if="item.children == undefined || item.children.length == 0"
          >
            <div class="flex">
              <i :class="item.menuIcon || 'fa fa-image'" :size="iconSize"></i>
              <span class="layout-text">{{item.menuName}}</span>
            </div>
            <Badge
              :count="$store.getters.inboxCount"
              style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
              v-if="item.menuCode == 'inbox'"
            ></Badge>
            <Badge
              :count="$store.getters.todoCount"
              style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
              v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
            ></Badge>
          </MenuItem>
          <sub-side-menu :item="item" :key="'menu-'+item.pathName+'-index'" v-else></sub-side-menu>
        </template>
      </MenuGroup>
    </Menu>
  </GeminiScrollbar>
</template>

<script>
import subSideMenu from './subSideMenu.vue'
export default {
  name: 'sidebarMenu',
  components: {
    subSideMenu
  },
  props: {
    accordion: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Object,
      default: {}
    },
    iconSize: Number,
    activeName: {
      type: String
    },
    menuTheme: {
      type: String,
      default: 'dark'
    },

  },
  computed: {
    menuLayoutType: function () {
      // return 'TOP'
      return this.$store.getters['systemInfo/menuLayout'] || 'LEFT'
    },
    isBack: function () {
      return this.$store.getters['menuInfo/isBack']
    },
    openNames: function () {
      let data = this.$store.getters['menuInfo/openNames'] || []
      this.opens = data
      this.$nextTick(() => {
        this.$refs.sideMenu.updateActiveName()
        this.$refs.sideMenu.updateOpened()
      })
      return data
      // return this.$store.getters['menuInfo/openNames'] || []
    },
  },
  data () {
    return {
      opens: []
    }
  },
  methods: {
    changeMenu (name) {
      console.log("this.openNames", this.opens)
      this.$emit('on-change', name)

      this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'openNames', value: this.opens })
    },
  },
};
</script>
